import React, { useEffect } from "react";
import { messaging } from "@shared/services/firebase";
import { onMessage } from "firebase/messaging";
import AppRoutes from "@routes/Index";
import ToastNotification from "@shared/tostNotification/ToastNotification";
import { ThemeProvider } from "@context/ThemeContext";
import { SocketProvider } from "@context/SocketContext";
import { useDispatch } from "react-redux";
import { incomingNotification } from "@/store/slices/notification.actions";
import CallSocketManager from "@features/call/components/CallSocketManager";
import CallLiveKitManager from "@features/call/components/CallLiveKitManager";

const App: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload: any) => {
      dispatch(incomingNotification(payload));
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <>
      <ThemeProvider>
        <SocketProvider>
          <ToastNotification />
          <CallSocketManager />
          <CallLiveKitManager />
          <AppRoutes />
        </SocketProvider>
      </ThemeProvider>
    </>
  );
};

export default App;

